import { Table } from "antd";
import styled from "styled-components";

export const StyledAnalysisActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-lg);
  margin: var(--spacing-sm) 0px;
`;

export const StyledValue = styled.p`
  margin: 3px;
  white-space: break-spaces;
  word-break: break-word;
`;

export const StyledPrompt = styled.span`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.25);
  font-weight: 600;
`;

export const StyledCircle = styled.div`
  display: flex;
  justify-content: center;
  &::before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
  }
`;

export const StyledTable = styled(Table)`
  .ant-table-tbody > tr > td {
    padding: var(--spacing-xs);
    text-align: center;
  }

  .ant-table-pagination.ant-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: var(--spacing-xs);
    row-gap: var(--spacing-xs);
  }

  .ant-pagination-total-text {
    display: flex !important;
    flex: 1 1 0 !important;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacing-xs-md);
    min-width: 0;
    margin-inline-end: var(--spacing-sm);
  }

  .row-overlay {
    position: relative;
  }

  .row-overlay td {
    position: relative;
  }

  .row-overlay td::before {
    content: "";
    position: absolute;
    inset: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    pointer-events: all;
    z-index: 2;
  }
`;

export const StyledSourceValuesTableWrapper = styled.div`
  @media (max-width: 1557px) {
    padding-top: 32px;
  }
`;

export const StyledAgentTableToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-xs-md);
  width: 100%;
  min-width: 0;

  .ant-checkbox-wrapper {
    flex: 0 0 auto;
  }

  .action-button {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .agent-table-toolbar__input {
    flex: 0 0 300px;
    width: 300px;
    min-width: 300px;
    max-width: 300px;
  }
`;
